/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  ScheduleComponent,
  ViewsDirective,
  ViewDirective,
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
} from '@syncfusion/ej2-react-schedule';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { DialogComponent, DialogUtility } from '@syncfusion/ej2-react-popups';
import { Link, useNavigate } from 'react-router-dom';
import { GridComponent, ColumnsDirective, ColumnDirective, Edit, Toolbar, Sort, Search, ExcelExport } from '@syncfusion/ej2-react-grids';
import { DatePickerComponent, DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { GroupContent, Header, EditorForm } from '../components';
import { useStateContext } from '../contexts/ContextProvider';
import scribeHow from '../data/scribehow.png';

import './Zackat.css';

// eslint-disable-next-line react/destructuring-assignment
const PropertyPane = (props) => <div className="mt-5">{props.children}</div>;

const Campaign = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=calendar');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const grid = useRef(null);
  // const [scheduleObj, setScheduleObj] = useState();
  const scheduleObj = useRef(null);

  // const [startTime, setStartTime] = useState(new Date());
  // const [endTime, setEndTime] = useState(new Date());
  // const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel' };
  // const toolbarOptions = [excel, 'Search'];
  const [changeDynamic, setChangeDyname] = useState(false);
  const [dynamicOptions, setDynamicOptions] = useState([]);
  const toolbarOptions = ['ExcelExport', 'Search'];
  const orgFieldSettings = { text: 'title', value: '_id' };
  const { REACT_APP_API_ENDPOINT } = process.env;
  const {
    boss,
    zRenderMode,
    isMobile,
    groups,
    setGroups,
    isDialogOpen,
    setIsDialogOpen,
  } = useStateContext();
  const change = (args) => {
    scheduleObj.selectedDate = args.value;
    scheduleObj.dataBind();
  };
  // In a method or event that runs after the Grid is initialized/rendered (e.g., the load event):
  const handleGridLoad = () => {
  // The search input is generally found within the toolbar, you might need to adjust the selector
  // based on your specific implementation and the component's version.
    if (!grid || !grid.current) {
      return;
    }
    const searchInput = grid.current.element.querySelector('.e-input-group.e-search .e-input');

    if (searchInput) {
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault(); // Stop the default form submission behavior
          // Optionally, you can trigger the grid's search programmatically here if needed
          grid.current.search(searchInput.value);
        }
      });
    }
  };
  useEffect(() => {
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/campaigngroup?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
        // set state when the data received
      if (mydata && mydata.length > 0) {
        const mygroups = [];
        // mygroups.push({ _id: 'na', name: 'Add New', associates: [], devices: [], organization: '' });
        mydata.forEach((element) => {
          mygroups.push(element);
        });
        setGroups(mygroups);
      } else {
        setGroups([]);
      }
    };
    dataFetch();
  }, []);
  const onDragStart = (arg) => {
    // eslint-disable-next-line no-param-reassign
    arg.navigation.enable = true;
  };
  const [data, setData] = useState([]);
  const [dropdownFotaData, setDropDownFotaData] = useState([]);
  const [dropdownData, setDropDownData] = useState([]);
  const [reload, setReload] = useState(false);
  const [logData, setLogData] = useState([]);
  const [smsData, setSmsData] = useState([]);
  const [isFota, setIsFota] = useState(false);
  const [eventType, setEventType] = useState('');
  const [maxLength, setMaxLength] = useState(1000);
  const [loading, setLoading] = useState(true);
  const [smsloading, setSMSLoading] = useState(true);
  const [isNewEvent, setIsNewEvent] = useState(true);
  const [editing, setEditing] = useState(false);
  const [subject, setSubject] = useState('');

  const grpbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setIsDialogOpen(false);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'Cancel',
      },
    },
  ];
  const grpTemplate = () => <GroupContent props={data} />;
  const onToolbarChange = (args) => {
    if (args && args.target && args.target.textContent) {
      if (args.target.textContent === 'Groups' || (args.target && args.target.classList.contains('e-selection'))) {
        setIsDialogOpen(true);
      }
    } else if (args.target && args.target.classList.contains('e-selection')) {
      setIsDialogOpen(true);
    }
  };
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Associates_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_CampaignLog_${new Date().toISOString()}.xlsx`,
        pageOrientation: 'Landscape',
      };
      grid.current.excelExport(properties);
    }
  };
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/campaign_events?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      // set state when the data received
      if (mydata && mydata.fotas) {
        setDropDownFotaData(mydata.fotas);
      }
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [reload]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const smsFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/sms_config?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      // set state when the data received
      setSmsData(mydata.sms);
      setSMSLoading(false);
    };
    smsFetch();
  }, [reload]);

  const fieldSettings = { text: 'text', value: 'value' };
  const smsFieldSettings = { text: 'name', value: 'syntax' };
  const fotaFieldSettings = { text: 'name', value: '_id' };
  const groupFieldSettings = { text: 'name', value: '_id' };
  useEffect(() => {
    const mydropdownData = [
      { text: 'FOTA', value: 'fota' },
      { text: 'Push Notification', value: 'push' },
      { text: 'SMS', value: 'sms' },
      { text: 'Email', value: 'email' },
      { text: 'Device Action', value: 'device' },
    ];
    setDropDownData(mydropdownData);
  }, []);

  const changeTypeSelection = (args) => {
    if (args && args.value) {
      setEventType(args.value);
      if (args && args.value === 'FOTA') {
        setIsFota(true);
      } else {
        setIsFota(false);
        setMaxLength(1000);
      }
      if (args && args.value === 'SMS') {
        setMaxLength(160);
      }
    }
  };
  const editorHeaderTemplate = (props) => (
    // Check if the event is new based on the presence of an `Id`
    // Display "New Campaign" for new events, or the event's subject for existing ones
    <div style={{ padding: '10px', fontSize: '18px', fontWeight: 'bold' }}>
        {isNewEvent ? 'New Campaign' : `Edit ${subject}`}
      </div>
  );
  const onPopupClose = (args) => {
    setEditing(false);
  };
  const onPopupOpen = (args) => {
    if (args.type === 'Editor') {
      setEditing(true);
      if (!args.data.Id || args.data.Id === '') {
        setIsNewEvent(true);
        setSubject('Campaign Event');
      } else {
        setIsNewEvent(false);
        setSubject(args.data.Subject);
      }
      const statusElement = args.element.querySelector('#EventType');
      if (statusElement) {
        statusElement.setAttribute('name', 'EventType');
      }
    } else {
      setEditing(false);
    }
    if (args.type === 'QuickInfo') {
      args.cancel = true; // Prevent quick info popup from rendering
      // scheduleObj.current.openEditor(args.data, 'EditEvent'); // Force direct editor template opening
    }
  };
  const editorTemplate = useCallback((props) => <EditorForm props={props} orgs={data.organization} fotas={dropdownFotaData} sms={smsData} />, [smsloading, loading]);

  const editorTemplateold = (props) => (props !== undefined ? (
    <div>
      <table className="custom-event-editor"><tbody>
      <tr><td className="e-textlabel custom-checkbox-label">Organization</td><td colSpan={4}><DropDownListComponent className="e-field e-textlabel custom-checkbox-label" id="organizationid" required placeholder="Choose Organization" data-name="organizationid" fields={orgFieldSettings} dataSource={data.organization} value={props.organizationid} /></td></tr>
      <tr><td className="e-textlabel">Type</td><td colSpan={4}><DropDownListComponent id="EventType" required placeholder="Choose Type" data-name="EventType" className="e-field" fields={fieldSettings} dataSource={dropdownData} value={props.EventType} onChange={(e) => { setChangeDyname(!changeDynamic); }} /></td></tr>
      <tr><td className="e-textlabel" title="Event Type FOTA only!">Image</td><td colSpan={4}><DropDownListComponent id="FotaImage" enabled placeholder="Choose FOTA" data-name="FOTAImage" className="e-field" fields={fotaFieldSettings} dataSource={dropdownFotaData} value={props.FOTAImage} /></td></tr>
      <tr><td className="e-textlabel">Name</td><td colSpan={4}><input id="Subject" className="e-field e-input" required type="text" placeholder="descriptive name" name="Subject" defaultValue={props.Subject} /></td></tr>
      <tr><td className="e-textlabel">From</td><td colSpan={4}><DateTimePickerComponent required format="MM/dd/yy hh:mm a" id="StartTime" data-name="StartTime" value={new Date(props.StartTime)} className="e-field" /></td></tr>
      <tr><td className="e-textlabel">To</td><td colSpan={4}><DateTimePickerComponent required format="MM/dd/yy hh:mm a" id="EndTime" data-name="EndTime" value={new Date(props.EndTime)} className="e-field" /></td></tr>
      <tr><td className="e-textlabel" title="Message payload will be sent to the selected Associates/Devices, if the event type is SMS, Email or Push, mobile app recipients will be selected for the assigned Associates/Devices. This field is ignored for FOTA event type!">Message</td><td colSpan={4}><textarea id="Description" placeholder="email, sms or push contents" maxLength={maxLength} className="e-field e-input" name="Description" rows={3} cols={50} value={props.message} /></td></tr>
      {/* <tr><td className="e-textlabel" title="Event Device Action!">Action</td><td colSpan={4}><DropDownListComponent id="actionMsg" enabled placeholder="Choose Device Action" data-name="DeviceAction" className="e-field" fields={smsFieldSettings} dataSource={smsData} value={props.message} /></td></tr> */}
      <tr><td className="e-textlabel">Group</td><td colSpan={4}><DropDownListComponent id="Group" popupWidth="300px" allowResize required placeholder="Choose Group" data-name="group" className="e-field" fields={groupFieldSettings} dataSource={groups} value={props.group} onChange={(e) => { if (e.value === 'na') { setIsDialogOpen(!isDialogOpen); } }} /></td></tr>
      <tr><td className="e-textlabel">Dynamic Dropdown</td><td colSpan={4}>
        <select defaultValue={props.message || ''}>
          {smsData.map((opt) => (
            <option key={opt.id} value={opt.syntax}>
              {opt.name}
            </option>
          ))}
        </select>
        </td>
        </tr>
    </tbody>
    </table>
      <div>
        {!isNewEvent && (
          <GridComponent
            ref={grid}
            id="gridcampaignlogs"
            dataSource={logData}
            allowSorting
            allowResizing
            width="100%"
            enableStickyHeader
            allowTextWrap
            // load={handleGridLoad}
            toolbarClick={clickHandler}
            allowExcelExport
            enableAdaptiveUI={isMobile}
            rowRenderingMode={zRenderMode}
            toolbar={toolbarOptions}
            enableAltRow
            enablePersistence
          >
          <ColumnsDirective>
            <ColumnDirective
              field="_id"
              headerText="ID"
              visible={false}
              isPrimaryKey
            />
            <ColumnDirective
              field="deviceName"
              headerText="Name"
            />
            <ColumnDirective
              field="log"
              headerText="Log"
            />
            <ColumnDirective
              field="timestamp"
              headerText="Timestamp"
            />
          </ColumnsDirective>
          <Inject services={[Edit, Toolbar, Sort, Resize, Search, ExcelExport]} />
        </GridComponent>
        )}
      </div>
    </div>
  ) : <div />);
  if (loading || smsloading) {
    return <p>Loading... </p>;
  }
  if (!boss) {
    return <p>Not Authorized... </p>;
  }
  const onRendercell = (args) => {
    (args.element).style.background = args.data.CategoryColor;
  };
  /*
  const actionBegin = (args) => {
    const mygroups = [];
    if (args && args.event) {
      setLogData(args.event.logs);
      groups.forEach((grp) => {
        if (grp.organizationid === args.event.organizationid) {
          mygroups.push(grp);
        }
      });
      setGroups(mygroups);
    } else {
      setLogData([]);
    }
  };
  */
  const onActionBegin = (args) => {
    // Check if the action is triggered by navigation or toolbar rendering,
    // and cancel it if a popup/modal interaction is in progress
    if (args.requestType === 'viewNavigate' || args.requestType === 'dateNavigate') {
      // Add your condition here to block changes if needed
      if (editing) {
        args.cancel = true;
      }
    }
  };

  const actionComplete = (args) => {
    let editedData;
    setEditing(false);
    if (!args || !args.requestType) {
      return;
    }
    if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
      /** Add Validation Rules */
    }
    /** Set initial Focus */
    if (args.requestType === 'eventCreated' && args.addedRecords.length > 0) {
      editedData = args.addedRecords;
      if (!editedData[0].EventType) {
        DialogUtility.alert('Please select an Event Type!');
        args.cancel = true;
        return;
      }
      if (editedData[0].FOTAImage && editedData[0].FOTAImage && editedData[0].FOTAImage.length > 0 && editedData[0].EventType !== 'fota') {
        DialogUtility.alert(`Event Type ${editedData[0].EventType} should not be assigned a FOTA Image!`);
        args.cancel = true;
        return;
      }
      if (editedData[0].Description && editedData[0].Description.length > 0 && editedData[0].EventType === 'fota') {
        DialogUtility.alert(`Message for Event Type ${editedData[0].EventType} should not be assigned!`);
        args.cancel = true;
        return;
      }
      if (editedData[0].FOTAImage && editedData[0].FOTAImage && editedData[0].FOTAImage.length === 0 && editedData[0].EventType === 'fota') {
        DialogUtility.alert(`FOTAImage for Event Type ${editedData[0].EventType} may not be omitted!`);
        args.cancel = true;
        return;
      }
      if (!editedData[0].organizationid) {
        DialogUtility.alert(`Please select an Organization for Event Type ${editedData[0].EventType}!`);
        args.cancel = true;
        return;
      }
      if (!editedData[0].group) {
        DialogUtility.alert(`Please select a Group for Event Type ${editedData[0].EventType}!`);
        args.cancel = true;
        return;
      }
      editedData[0].stime = new Date(editedData[0].StartTime).getTime() / 1000;
      editedData[0].etime = new Date(editedData[0].EndTime).getTime() / 1000;
      if (editedData[0].etime <= new Date().getTime() / 1000) {
        DialogUtility.alert(`Event Type ${editedData[0].EventType} has already passed ${editedData[0].EndTime}!`);
        args.cancel = true;
        return;
      }
      switch (editedData[0].EventType) {
        case 'sms':
          editedData[0].CategoryColor = '#00ffff';
          break;
        case 'push':
          editedData[0].CategoryColor = '#78DA89';
          break;
        case 'email':
          editedData[0].CategoryColor = '#1E1B1B';
          break;
        case 'fota':
          editedData[0].CategoryColor = '#aaaaaa';
          break;
        case 'device':
          editedData[0].CategoryColor = '#557755';
          break;
        default:
          break;
      }
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      fetch(`${REACT_APP_API_ENDPOINT}/campaign_events`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson._id) {
            for (let i = 0; i < args.addedRecords.length; i += 1) {
              if (responseJson[i] && responseJson[i]._id) {
                args.addedRecords[i]._id = responseJson[i]._id;
              }
            }
          }
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (args.requestType === 'eventChanged' && args.changedRecords.length > 0) {
      editedData = args.changedRecords;
      if (!editedData[0].EventType) {
        DialogUtility.alert('Please select an Event Type!');
        args.cancel = true;
        return;
      }
      /*
      if (editedData[0].FOTAImage && editedData[0].FOTAImage.length > 0 && editedData[0].EventType !== 'fota') {
        DialogUtility.alert(`Event Type ${editedData[0].EventType} should not be assigned a FOTA Image!`);
        args.cancel = true;
        return;
      }
      */
      if (editedData[0].Description && editedData[0].Description.length > 0 && editedData[0].EventType === 'fota') {
        DialogUtility.alert(`Message for Event Type ${editedData[0].EventType} should not be assigned!`);
        args.cancel = true;
        return;
      }
      if (editedData[0].FOTAImage && editedData[0].FOTAImage.length === 0 && editedData[0].EventType === 'fota') {
        DialogUtility.alert(`FOTAImage for Event Type ${editedData[0].EventType} may not be omitted!`);
        args.cancel = true;
        return;
      }
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      editedData[0].stime = new Date(editedData[0].StartTime).getTime() / 1000;
      editedData[0].etime = new Date(editedData[0].EndTime).getTime() / 1000;
      if (editedData[0].etime <= new Date().getTime() / 1000) {
        DialogUtility.alert(`Event Type ${editedData[0].EventType} has already passed ${editedData[0].EndTime}!`);
        args.cancel = true;
        return;
      }
      if (!editedData[0].organizationid) {
        DialogUtility.alert(`Please select an Organization for Event Type ${editedData[0].EventType}!`);
        args.cancel = true;
        return;
      }
      if (!editedData[0].group) {
        DialogUtility.alert(`Please select a Group for Event Type ${editedData[0].EventType}!`);
        args.cancel = true;
        return;
      }
      editedData[0].logs = null;
      fetch(`${REACT_APP_API_ENDPOINT}/campaign_events`, {
        method: 'UPDATE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),

      })
        .then((response) => response.json())
        .then((responseJson) => {
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (args.requestType === 'eventRemoved' && args.deletedRecords.length > 0) {
      editedData = args.deletedRecords;
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      fetch(`${REACT_APP_API_ENDPOINT}/campaign_events`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),

      })
        .then((response) => response.json())
        .then((responseJson) => {
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
            <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Campaigns_use_and_features__eHkvNLXqQ66fYHg6tlLrlQ"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
      <Header category="Apps" title="Campaign" />
      </div>
      <ToolbarComponent id="toolbar" onClick={onToolbarChange} overflowMode="MultiRow">
        <ItemsDirective>
          <ItemDirective text="Groups" prefixIcon="e-selection" visible />
      </ItemsDirective></ToolbarComponent>
      <ScheduleComponent
        height="650px"
        ref={scheduleObj}
        selectedDate={new Date()}
        eventSettings={{ dataSource: data.campaign }}
        eventRendered={onRendercell}
        dragStart={onDragStart}
        popupOpen={onPopupOpen}
        popupClose={onPopupClose}
        showQuickInfo={false}
        editorTemplate={editorTemplate}
        editorHeaderTemplate={editorHeaderTemplate}
        actionComplete={actionComplete}
        actionBegin={onActionBegin}
        // eventClick={actionBegin}
      >
        <ViewsDirective>
          {['Day', 'Week', 'WorkWeek', 'Month', 'Agenda'].map((item) => (
            <ViewDirective
              key={item}
              option={item}
            />
          ))}
        </ViewsDirective>
        <Inject services={[Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop]} />
      </ScheduleComponent>
      {/*
      <PropertyPane>
        <table
          style={{ width: '100%', background: 'white' }}
        >
          <tbody>
            <tr style={{ height: '50px' }}>
              <td style={{ width: '100%' }}>
                <DatePickerComponent
                  value={new Date()}
                  showClearButton={false}
                  placeholder="Current Date"
                  floatLabelType="Always"
                  change={change}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </PropertyPane>
      */}
      {isDialogOpen && (
        <DialogComponent
          header="Campaign Groups"
          content={grpTemplate}
          buttons={grpbuttons}
          width="75%"
          height="75%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setIsDialogOpen(false); }}
          close={() => { setIsDialogOpen(false); }}
        />
      )}
    </div>
  );
};

export default Campaign;
